var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.7,
    height: 17,
    viewBox: "0 0 18.7 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-filter",
    "data-name": "Icon feather-filter",
    d: "M2.35,3h17A.85.85,0,0,1,20,4.4l-6.6,7.8V19.15a.85.85,0,0,1-1.23.76l-3.4-1.7a.85.85,0,0,1-.47-.76V12.2L1.7,4.4A.85.85,0,0,1,2.35,3ZM17.518,4.7H4.182L9.8,11.342a.85.85,0,0,1,.2.549v5.034l1.7.85V11.891a.85.85,0,0,1,.2-.549Z",
    transform: "translate(-1.5 -3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.a05e8058e119cba3cf7897d8d95f8ac7.svg";
export { ForwardRef as ReactComponent };